export default __webpack_public_path__ + "static/portfolio_gallery_12-af93498e1d65b1a74e787374a09e13ab.jpg";